import React from 'react';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';

const PrimeDialogComponent = ({
  visible = null,
  onHide = null,
  modal = null,
  footer = null,
  header = null,
  maximizable = null,
  content = null,
  className = null,
  style = null,
}) => {
  PrimeDialogComponent.propTypes = {
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    modal: PropTypes.bool,
    footer: PropTypes.any,
    header: PropTypes.string,
    maximizable: PropTypes.bool,
    content: PropTypes.any,
    className: PropTypes.string,
    style: PropTypes.any,
  };

  return (
    <Dialog
      header={header}
      visible={visible}
      modal={modal}
      maximizable={maximizable}
      onHide={onHide}
      footer={footer}
      className={className}
      style={style}>
      {content}
    </Dialog>
  );
};

export default PrimeDialogComponent;